import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    fontWeight: 700,
    marginTop: 24
  },
}))

const Heading = () => {
  const classes = useStyles();
  let { league } = useParams<any>();

  return (
    <div className={classes.root}>
      <Typography variant='h4' className={classes.header} align='center'>
        {league} DFS Player Compare
      </Typography>
    </div>
  )
}

export default Heading;